<template>
    <Container class="px-[18px]">
        <div class="hidden md:block">
            <div class="flex space-x-[22px] mb-[24px]">
                <a v-for="(tabItem, index) in tabs"
                   :key="index"
                   @click="tab = index"
                   :class="`text-[24px] font-[600] cursor-pointer pb-[16px] border-b-[7px] ${tab === index ? 'border-primary-500' : ''}`">
                    {{ tabItem.title }}
                </a>
            </div>

            <div class="relative">
                <img :src="imageSrc" :width="imageWidth" alt="" class="hidden md:block absolute top-[-76px] right-[50px]" />

                <div v-for="(tabItem, tabIndex) in tabs"
                     :key="tabIndex"
                     v-show="tab === tabIndex"
                     class="flex justify-between bg-primary-100 rounded-xl p-[36px] gap-[15px]">
                    <div class="w-[48%] space-y-[15px]">
                        <p v-for="(item, index) in tabItem.items.slice(0, Math.ceil(tabItem.items.length/2))" :key="index">
                            <b>{{ item.name }}</b>, {{ item.title }}
                        </p>
                    </div>
                    <div class="w-[48%] space-y-[15px]">
                        <p v-for="(item, index) in tabItem.items.slice(Math.ceil(tabItem.items.length/2))" :key="index">
                            <b>{{ item.name }}</b>, {{ item.title }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="block md:hidden space-y-[11px]">
            <div v-for="(tabItem, tabIndex) in tabs" :key="tabIndex">
                <div :class="[tab === tabIndex ? 'rounded-tl-xl rounded-tr-xl bg-primary-100' : 'rounded-xl bg-primary-100', 'cursor-pointer flex justify-between px-[15px] py-[8px] h-[40px] items-center']"
                    @click="tab === tabIndex ? tab = null : tab = tabIndex">
                    <span>{{ tabItem.title }}</span>

                    <span>
                        <svg :class="tab !== tabIndex ? '' : 'rotate-180'" xmlns="http://www.w3.org/2000/svg"
                            width="12" height="7" viewBox="0 0 12 7" fill="none">
                            <path d="M5.99935 6.50033L0.166016 0.666992H11.8327L5.99935 6.50033Z" fill="#2B2B2B" />
                        </svg>
                    </span>
                </div>

                <div v-if="tab === tabIndex" class="p-[16px] bg-primary-100 rounded-bl-xl rounded-br-xl">
                    <div class="space-y-[15px]">
                        <p v-for="(item, index) in tabItem.items" :key="index">
                            <b>{{ item.name }}</b>, {{ item.title }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </Container>
</template>

<script>
import Container from '../../../Layouts/Container'

export default {
    components: {
        Container,
    },
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        imageSrc: String,
        imageWidth: String,
    },
    data() {
        return {
            tab: 0,
        }
    }
}
</script>
